import { apiClient } from "@/lib/api/client";
import type { CommandCreateDto, CommandDto } from "@/lib/api/types";

export async function sendCommand(body: CommandCreateDto): Promise<CommandDto> {
  const { data } = await apiClient.post<CommandDto>("/commands", body);
  return data;
}

export async function listCommandsForDevice(
  deviceId: string,
  params?: { limit?: number },
): Promise<CommandDto[]> {
  const limit = params?.limit ?? 100;
  const { data } = await apiClient.get<CommandDto[]>("/commands", {
    params: { device_id: deviceId, limit },
  });
  return data;
}

export async function getCommandById(commandId: string): Promise<CommandDto> {
  const { data } = await apiClient.get<CommandDto>(`/commands/${commandId}`);
  return data;
}
